import React from 'react';

/**
 * THE stacked PO cell's TOP LINE — PO on top, conditionally, over an order
 * number a caller renders itself. Extracted 2026-09-28 out of
 * `components/OrderTableView.js`'s `po_number` cell when the hires Table
 * (`components/hires/HireTableView.js`) needed the identical top line for
 * its own PO/Order column (owner: *"Dept Hires table needs the columns
 * arranged a little more like Dept orders ... it needs the PO number sort
 * feature when we click on the order number like dept orders"*).
 *
 * 🔑 **ONLY THE TOP LINE — never the whole cell** on DESKTOP: Dept Orders'
 * desktop cell also carries its click-through and the completed-order green
 * text. 🔀 2026-10-03: on a PHONE the WHOLE cell is shared —
 * `components/PhonePoOrderCell.js`, every phone table — and the hires cells
 * (both widths) no longer link to the order at all (owner: a tap expands).
 *
 * 🔴 **THE CONDITIONAL IS THE DESIGN, not a tidy-up** — see
 * `OrderTableView.js`'s own docblock at its `po_number` cell for the full
 * reasoning (the large majority of orders/hires carry no PO, so an
 * unconditional two-line cell would render a blank top line on almost every
 * row). No PO → renders nothing, and the caller's own order-number line sits
 * alone with no blank line above it.
 */
export default function PoOrderTopLine({ poNumber, testId, className = '' }) {
  if (!poNumber) return null;
  return (
    <div
      className={`truncate leading-tight ${className}`}
      title={poNumber}
      data-testid={testId}
    >
      {poNumber}
    </div>
  );
}
